import React, { useContext, useMemo, useState } from "react";
import "../css/shop.scss";
import { Link, useSearchParams } from "react-router-dom";
import { FiHeart, FiSliders } from "react-icons/fi";
import productData from "../Datas/productData";
import { CartContext } from "./CartContext";

export function ProductCard({ product }) {
  const { wishlist, toggleWishlist } = useContext(CartContext);
  const liked = wishlist.includes(product.id);
  return <article className="product-card">
    <div className="product-card__image">
      <Link to={`/shopDetails/${product.id}`} onClick={() => window.scrollTo(0, 0)}><img src={product.image} alt={product.name} loading="lazy" /></Link>
      <button className={liked ? "liked" : ""} onClick={() => toggleWishlist(product.id)} aria-label={liked ? "Remove from wishlist" : "Add to wishlist"}><FiHeart /></button>
      {product.featured && <span>NEW</span>}
    </div>
    <div className="product-card__details"><p>{product.category}</p><Link to={`/shopDetails/${product.id}`} onClick={() => window.scrollTo(0, 0)}>{product.name}</Link><strong>${product.price.toFixed(2)}</strong></div>
  </article>;
}

function Shop() {
  const [params] = useSearchParams();
  const search = params.get("q") || "";
  const [category, setCategory] = useState("All");
  const [sort, setSort] = useState("featured");
  const [filtersOpen, setFiltersOpen] = useState(false);
  const categories = ["All", ...new Set(productData.map((item) => item.category))];
  const products = useMemo(() => {
    const needle = search.toLowerCase();
    const result = productData.filter((item) => (category === "All" || item.category === category) && (!needle || `${item.name} ${item.category} ${item.tags.join(" ")}`.toLowerCase().includes(needle)));
    return [...result].sort((a, b) => sort === "low" ? a.price - b.price : sort === "high" ? b.price - a.price : sort === "az" ? a.name.localeCompare(b.name) : Number(b.featured) - Number(a.featured));
  }, [category, search, sort]);

  return <main className="shop">
    <header className="shop-hero"><p>THE LATEST EDIT</p><h1>{search ? `Search: “${search}”` : "New in-store"}</h1><span>Colourful, useful and a little unexpected. Meet our newest finds.</span></header>
    <div className="shop-toolbar">
      <button className="filter-toggle" onClick={() => setFiltersOpen(!filtersOpen)}><FiSliders /> FILTER</button>
      <div className={`category-list ${filtersOpen ? "open" : ""}`}>{categories.map((item) => <button className={category === item ? "active" : ""} key={item} onClick={() => setCategory(item)}>{item}</button>)}</div>
      <label>SORT BY <select value={sort} onChange={(e) => setSort(e.target.value)}><option value="featured">Featured</option><option value="low">Price, low to high</option><option value="high">Price, high to low</option><option value="az">Alphabetically, A–Z</option></select></label>
    </div>
    <div className="shop-count">{products.length} PRODUCTS</div>
    {products.length ? <section className="product-grid">{products.map((product) => <ProductCard product={product} key={product.id} />)}</section> : <div className="no-results"><h2>No treasures found</h2><p>Try a broader search or another category.</p></div>}
  </main>;
}
export default Shop;
